// extracted by mini-css-extract-plugin
module.exports = {"carouselButton":"CarouselButton_carouselButton__Dabvh"};